@if (isActive) {
    <p-tag [value]="l('::Active')" class="active-tag" [rounded]="true"></p-tag>
} @else {
    <p-tag [value]="l('::Inactive')" class="inactive-tag" [rounded]="true"></p-tag>
}